<template>
    <div class="content-spacer-shadow flex justify-center w-full min-h-[6px]">
        <slot />
    </div>
</template>

<style scoped lang="scss">

.content-spacer-shadow
{
    box-shadow: 0 2px 4px -2px rgba( var( --RGB-gray-900 ), 0.1);
    transform: scaleY(-1);
    transform-origin: 0 100%;

    &:after
    {
        content: "";
        position: absolute;
        top: 100%;
        opacity: 60%;
        bottom:0;
        width:100%;
        height:30px;
        //background: -webkit-radial-gradient(50% -3%, ellipse cover, rgba(var( --RGB-gray-900 ), 0.5), rgba(var( --RGB-gray-900 ), 0.3), rgba(var( --RGB-gray-900 ), 0) 50%);
        background: radial-gradient( ellipse at 50% -3%, rgba( var( --RGB-gray-200 ), 0.5), rgba(var( --RGB-gray-200 ), 0.3), rgba(var( --RGB-gray-200 ), 0) 50%);        
    }
}

.dark
{
    .content-spacer-shadow
    {
        box-shadow: 0 2px 4px -2px rgba( var( --RGB-gray-900 ), 0.4);

        &:after
        {
            //background: -webkit-radial-gradient(50% -3%, ellipse cover, rgba(var( --RGB-gray-900 ), 0.5), rgba(var( --RGB-gray-900 ), 0.3), rgba(var( --RGB-gray-900 ), 0) 50%);
            background: radial-gradient( ellipse at 50% -3%, rgba( var( --RGB-gray-900 ), 0.5), rgba(var( --RGB-gray-900 ), 0.3), rgba(var( --RGB-gray-900 ), 0) 50%);        
        }
    }
}

</style>